import React, {Component} from 'react';
import _ from 'lodash';

import {geoUtils} from '../utils/geo-utils';

const stateNameMap = {
  "1": {n: "Alabama", a: "AL"},
  "2": {n: "Alaska", a: "AK"},
  "4": {n: "Arizona", a: "AZ"},
  "5": {n: "Arkansas", a: "AR"},
  "6": {n: "California", a: "CA"},
  "8": {n: "Colorado", a: "CO"},
  "9": {n: "Connecticut", a: "CT"},
  "10": {n: "Delaware", a: "DE"},
  "11": {n: "District of Columbia", a: "DC"},
  "12": {n: "Florida", a: "FL"},
  "13": {n: "Georgia", a: "GA"},
  "15": {n: "Hawaii", a: "HI"},
  "16": {n: "Idaho", a: "ID"},
  "17": {n: "Illinois", a: "IL"},
  "18": {n: "Indiana", a: "IN"},
  "19": {n: "Iowa", a: "IA"},
  "20": {n: "Kansas", a: "KS"},
  "21": {n: "Kentucky", a: "KY"},
  "22": {n: "Louisiana", a: "LA"},
  "23": {n: "Maine", a: "ME"},
  "24": {n: "Maryland", a: "MD"},
  "25": {n: "Massachusetts", a: "MA"},
  "26": {n: "Michigan", a: "MI"},
  "27": {n: "Minnesota", a: "MN"},
  "28": {n: "Mississippi", a: "MS"},
  "29": {n: "Missouri", a: "MO"},
  "30": {n: "Montana", a: "MT"},
  "31": {n: "Nebraska", a: "NE"},
  "32": {n: "Nevada", a: "NV"},
  "33": {n: "New Hampshire", a: "NH"},
  "34": {n: "New Jersey", a: "NJ"},
  "35": {n: "New Mexico", a: "NM"},
  "36": {n: "New York", a: "NY"},
  "37": {n: "North Carolina", a: "NC"},
  "38": {n: "North Dakota", a: "ND"},
  "39": {n: "Ohio", a: "OH"},
  "40": {n: "Oklahoma", a: "OK"},
  "41": {n: "Oregon", a: "OR"},
  "42": {n: "Pennsylvania", a: "PA"},
  "44": {n: "Rhode Island", a: "RI"},
  "45": {n: "South Carolina", a: "SC"},
  "46": {n: "South Dakota", a: "SD"},
  "47": {n: "Tennessee", a: "TN"},
  "48": {n: "Texas", a: "TX"},
  "49": {n: "Utah", a: "UT"},
  "50": {n: "Vermont", a: "VT"},
  "51": {n: "Virginia", a: "VA"},
  "53": {n: "Washington", a: "WA"},
  "54": {n: "West Virginia", a: "WV"},
  "55": {n: "Wisconsin", a: "WI"},
  "56": {n: "Wyoming", a: "WY"},
  "72": {n: "Puerto Rico", a: "PR"},
  "78": {n: "Virgin Islands", a: "VI"}
};

class UsaStateLabels extends Component {

  shouldComponentUpdate(nextProps) {
    const widthDifferent = nextProps.width !== this.props.width;
    const heightDifferent = nextProps.height !== this.props.height;

    return widthDifferent || heightDifferent;
  }

  render() {
    const paths = geoUtils.getAlbersUsaStatePaths(this.props.width, this.props.height);
    const filteredPaths = _.filter(paths, d => d.path);

    const stateAbbr = d => {
      const abbr = _.get(stateNameMap, [d.id, 'a'], '');
      return _.includes(['DC', 'DE', 'RI', 'PR', 'VI'], abbr) ? '' : abbr;
    };

    return (
      <g className="UsaStateLabels">
        {filteredPaths.map(d => {
          return (
            <text
              key={d.id}
              className="outline"
              textAnchor="middle"
              transform={"translate(" + d.cent + ")"}
            >{stateAbbr(d)}</text>
          );
        })}
      </g>
    )
  }
}

export default UsaStateLabels


// WEBPACK FOOTER //
// ./src/charts/Map/UsaStateLabels.js